import React from "react";
import { alpha, Box, Typography } from "@mui/material";

// Props:
// - label: string
// - value: number|string
// - color: hex/string (used for button background)
// - icon: MUI Icon component (optional)
// - actionLabel: string for placeholder button (optional)
// - onActionClick: handler (optional)
const KPICard = ({ label, value, color = "#1976d2", icon: Icon, onActionClick, active = false, sx = {} }) => {
  const handleClick = () => {
    if (typeof onActionClick === "function") onActionClick();
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        flex: '1 1 160px',
        maxWidth: 220,
        minWidth: 160,
        borderRadius: "8px",
        p: 2,
        bgcolor: active ? alpha(color, 0.08) : "background.paper",
        border: active ? `2px solid ${alpha(color, 0.5)}` : "1px solid transparent",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        columnGap: 2,
        cursor: onActionClick ? "pointer" : "default",
        ...sx,
      }}
    >
      <Box>
        <Typography variant="overline" sx={{
          color: "text.secondary", letterSpacing: 1, overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {label}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          {value}
        </Typography>
      </Box>
      <Box
        onClick={(e) => {
          e.stopPropagation();
          handleClick();
        }}
        sx={{
          width: 35,
          height: 35,
          minWidth: 35,
          minHeight: 35,
          borderRadius: "50% !important",
          backgroundColor: alpha(color, 0.1),
          color: color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&:hover": {
            backgroundColor: alpha(color, 0.2),
          },
          cursor: 'pointer'
        }}>
        {Icon ? <Icon /> : null}

      </Box>
    </Box>
  );
};

export default KPICard;
